<template>
    <div id="emergency-contact-information">
        <v-card-title>
            <v-icon left :color="kingsGold">mdi-card-account-mail</v-icon>Parent/Guardian Contact Information Form
        </v-card-title>
        <v-card-subtitle class="pb-0">Please provide information for a parent, guardian or supportive person who could
            assist you
            during an emergency or difficult time.</v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-account-box</v-icon>Basic Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.title" hide-details label="Title"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.fullName" hide-details
                            label="Full Name" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.relationship" hide-details
                            label="Relationship" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-home</v-icon> Address Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.address" hide-details
                            label="Home Address" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.postalCode" hide-details
                            label="Postal Code" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.country" hide-details label="Country"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.city" hide-details label="City"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.province" hide-details
                            label="Province" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.provinceOther" hide-details
                            label="Province (Other)" placeholder="None" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-card-account-details</v-icon>Contact Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.homePhone" hide-details
                            label="Home Phone" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.cellPhone" hide-details
                            label="Cell Phone" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.parentGuardianEmergencyContact.email" hide-details label="Email"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
name: 'application-emergency-contact-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>